import { RichTextEditor as BasePoeRichTextEditor } from '@maxroll-media-group/common-libs'
import classNames from 'classnames'
import { SerializedEditorState } from 'lexical'
import './RichTextEditor.scss'
import { EmbedRenderer } from './utils/EmbedRenderer'
import { EmbedToolbar } from './utils/EmbedToolbar'

const poeColors = [
  // Common
  {
    name: 'Font Color',
    slug: 'light-gray',
    color: '#e3e3e3'
  },
  {
    name: 'Background',
    slug: 'near-black',
    color: '#0C0E0F'
  },
  {
    name: 'Maxroll Blue',
    slug: 'mid-blue',
    color: '#057af0'
  },
  {
    name: 'Green + / Zones / Pros',
    slug: 'mid-grean',
    color: '#4B9257'
  },
  {
    name: 'Red - / Life / Vitality',
    slug: 'mid-red',
    color: '#851522'
  },
  {
    name: 'For embed items in accordions e.g. mechanics',
    slug: 'really-black',
    color: '#131313'
  },

  // PoE
  {
    name: 'Magic item',
    slug: 'poe-magic-item',
    color: '#8888ff'
  },
  {
    name: 'Rare item',
    slug: 'poe-rare-item',
    color: '#ffff77'
  },
  {
    name: 'Unique item',
    slug: 'poe-unique-item',
    color: '#af6025'
  },
  {
    name: 'Skill gem',
    slug: 'poe-skill-gem',
    color: '#1ba29b'
  },
  {
    name: 'Currency',
    slug: 'poe-currency',
    color: '#aa9e82'
  },
  {
    name: 'Quest item',
    slug: 'poe-quest-item',
    color: '#4ae63a'
  },
  {
    name: 'Divination Card',
    slug: 'poe-divination-card',
    color: '#0ebaff'
  },
  {
    name: 'Fire damage',
    slug: 'poe-fire-damage',
    color: '#960000'
  },
  {
    name: 'Cold damage',
    slug: 'poe-cold-damage',
    color: '#366492'
  },
  {
    name: 'Lightning damage',
    slug: 'poe-lighning-damage',
    color: '#ffd700'
  },
  {
    name: 'Chaos damage',
    slug: 'poe-chaos-damage',
    color: '#d02090'
  },
  {
    name: 'Corrupted',
    slug: 'poe-corrupted',
    color: '#d20000'
  },
  {
    name: 'Crafted mod',
    slug: 'poe-crafted-mod',
    color: '#b8daf2'
  },
  {
    name: 'Scourge Orange',
    slug: 'poe-scourge-orange',
    color: '#ff6e25'
  },
  {
    name: 'Essence Blue',
    slug: 'poe-essence-blue',
    color: '#33d7ff'
  },
  {
    name: 'Prophecy Purple',
    slug: 'poe-prophecy-purple',
    color: '#b44bff'
  },
  {
    name: 'Tooltip Beige',
    slug: 'poe-tooltip-beige',
    color: '#f8e6ca'
  },
  {
    name: 'White Rarity Item',
    slug: 'poe-white-rarity-item',
    color: '#c8c8c8'
  },
  {
    name: 'Grey Tooltip Comment',
    slug: 'poe-grey-tooltip-comment',
    color: '#7f7f7f'
  },
  {
    name: 'Harvest Blue Seed',
    slug: 'poe-harvest-blue-seed',
    color: '#00f5ff'
  },
  {
    name: 'Harvest Yellow Seed',
    slug: 'poe-harvest-yellow-seed',
    color: '#fffa00'
  },
  {
    name: 'Harvest Purple Seed',
    slug: 'poe-harvest-purple-seed',
    color: '#ff00eb'
  }
]

export type { SerializedEditorState }

export function RichTextEditor({
  value,
  onChange,
  isEditing = false,
  render = true,
  isRestricted = false
}: {
  value: SerializedEditorState | undefined
  onChange?: (value: SerializedEditorState) => void
  isEditing?: boolean
  render?: boolean
  isRestricted?: boolean
}) {
  return render ? (
    <BasePoeRichTextEditor
      className={classNames('poe-rich-text-editor', isEditing && 'poe-rte-is-editing')}
      value={value}
      onChange={(newValue) => {
        if (onChange) {
          onChange(newValue)
        }
      }}
      isEditing={isEditing}
      settings={{ showTreeView: false }}
      suggestedColors={poeColors}
      theme={{ embedRenderer: EmbedRenderer, embedToolbar: EmbedToolbar }}
      isRestricted={isRestricted}
    />
  ) : null
}
